import {useEffect, useState} from "react";
import {useQuery} from "react-query";
import {Link} from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/react";
import {BsFilter, BsSearch} from "react-icons/bs";
import {NavHeader} from "../../../components/NavHeader";
import {Sidebar} from "../../../components/Sidebar";
import Spinner from "../../../components/Spinner";
import colours from "../../../styles/appColours";
import {Capitalize, getDate} from "../../../utils/utils";
import Filter from "../../../components/Filter";
import AppLayout from "../../../layouts/AdminLayout";

export const CustomersList = () => {
  const Baseurl = process.env.REACT_APP_BASEURL;
  const getToken: any = localStorage.getItem("eftd-admin-token");
  const tokenObject: any = JSON.parse(getToken);
  const token = tokenObject?.data?.data?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [searchFilter, setSearchFilter] = useState<any>();
  const [page, setPage] = useState(1);
  const [selectedTab, setSelectedTab] = useState("ALL");
  const [selectedLabel, setSelectedLabel] = useState("Export");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const getCustomers = async () => {
    let url = `${Baseurl}/api/admin/customers/getcustomers?limit=20&page=${page}`;

    if (debouncedSearchQuery) {
      url += `&query=${encodeURIComponent(debouncedSearchQuery)}`;
    }

    const response = await axios.get(url, {...config});
    return response?.data?.data?.items;
  };

  const {
    data: allCustomers,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery(["CUSTOMERS", searchFilter, page], getCustomers, {
    keepPreviousData: true,
  });

  useEffect(() => {
    refetch();
  }, [debouncedSearchQuery, refetch]);

  function goToNextPage() {
    setPage((page: number) => page + 1);
  }
  function gotolastPage() {
    setPage(allCustomers?.paging?.totalPages);
  }

  function goToPreviousPage() {
    setPage((page: number) => page - 1);
  }

  function changePage(event: any) {
    const pageNumber = Number(event.target.textContent);
    setPage(pageNumber);
  }

  const getPaginationGroup = () => {
    let total = Math.ceil(allCustomers?.paging?.totalPages) || 0;
    let pagination = new Array(total).fill(0).map((_, idx) => idx + 1);
    if (pagination.length > 8) {
      pagination.length = 9;
    }
    return pagination;
  };

  const customerTabs = [
    {label: "All", value: "ALL"},
    {label: "Individual", value: "INDIVIDUAL"},
    {label: "SME", value: "SME"},
    {label: "Corporates", value: "BUSINESS"},
  ];

  const STATUS_OPTIONS = [
    {label: "All", value: ""},
    {label: "Export .xlxs", value: "XLXS"},
    {label: "Export .csv", value: "CSV"},
    {label: "Export .json", value: "JSON"},
  ];

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [searchQuery]);

  const filteredCustomers = allCustomers?.filter((customer: any) => {
    if (selectedTab === "ALL") return true;
    return customer.accountType?.toUpperCase() === selectedTab;
  });

  return (
    <AppLayout>
      <div className="p-5">
        <div className="flex items-center justify-between pb-10">
          <div>
            <h3 className="!text-[28px] !font-bold !text-[#272835]">
              Customers
            </h3>
            <p className="!text-sm !text-[#818898]">
              View and track all your customers
            </p>
          </div>
          {/* <Link
            to={"/orders/create"}
            className="!text-sm !font-bold !text-white px-4 py-3 bg-[#f27f1f] rounded-[10px]"
          >
            Create Order
          </Link> */}
        </div>

        {/* <NavHeader title="Customers" /> */}
        {/* <Filter
          handleSearchFilter={setSearchFilter}
          showAccountTypeFilter={true}
          showStatusFilter={false}
        /> */}

        {/* Tabs */}
        <div className="flex justify-between border-b border-gray-200 mb-4">
          <div className="flex space-x-4">
            {customerTabs.map((tab) => (
              <button
                key={tab.value}
                onClick={() => setSelectedTab(tab.value)}
                className={`text-sm font-semibold pb-3 border-b-2 ${
                  selectedTab === tab.value
                    ? "text-gray-700 border-gray-700"
                    : "text-gray-400 border-transparent"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="border border-gray-100 rounded-[20px] overflow-auto">
          <div className="flex !items-center !justify-between px-6 !py-4">
            <h3 className="!text-xl !font-bold !text-gray-700">
              {selectedTab.charAt(0).toUpperCase() +
                selectedTab.slice(1).toLowerCase() +
                " "}
              Customers
            </h3>

            <div className="flex !gap-3">
              <div className="relative !h-12 !bg-gray-50 !border !rounded-lg !w-96 !border-gray-300">
                <input
                  type="text"
                  placeholder="Search custormers"
                  className="w-full h-full !pl-12 !text-sm !bg-transparent !outline-none !placeholder:text-gray-400"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <BsSearch className="absolute left-4 top-3.5 text-gray-400" />
              </div>

              {/* <Menu as="div" className="relative">
                <MenuButton className="flex !items-center !gap-2 !px-3 !py-3 !text-sm !font-medium !border !rounded-lg !border-gray-300 !text-gray-600">
                  <BsFilter />
                  <span>{selectedLabel}</span>
                </MenuButton>
                <MenuItems className="!absolute !right-0 !z-10 !w-48 !mt-2 !bg-white !border !border-gray-200 !rounded-md !shadow-lg">
                  {STATUS_OPTIONS.map((option) => (
                    <MenuItem key={option.value}>
                      {({active}) => (
                        <button
                          className={`!block !w-full !px-4 !py-2 t!ext-left !text-sm ${
                            active ? "!bg-gray-100" : ""
                          }`}
                          onClick={() => {
                            setSelectedLabel(option.label);
                            setSelectedStatus(option.value);
                          }}
                        >
                          {option.label}
                        </button>
                      )}
                    </MenuItem>
                  ))}
                </MenuItems>
              </Menu> */}
            </div>
          </div>

          <Table className="text-left">
            <div className="bg-gray-100">
              <RowHeader className="!bg-gray-100 text-left pl-0">
                <IDHeader className="!text-left  !pl-0">Name</IDHeader>
                <IDHeader className="!text-left  !pl-0">Date Joined</IDHeader>
                <IDHeader className="!text-left  !pl-0">Email</IDHeader>
                <IDHeader className="!text-left  !pl-0">Phone Number</IDHeader>
                <IDHeader className="!text-left  !pl-0">Account type</IDHeader>
                <IDHeader className="!text-left  !pl-0">Subscription</IDHeader>
                <IDHeader className="!text-left  !pl-0">Verified</IDHeader>
                <IDHeader>Action</IDHeader>
              </RowHeader>
            </div>

            {isLoading || isRefetching ? (
              <Spinner componentlevel />
            ) : filteredCustomers?.length > 0 ? (
              filteredCustomers.map((item: any, index: number) => (
                <Row
                  key={index}
                  className="border-b border-gray-100 hover:bg-gray-100 transition-colors text-left  pl-0"
                >
                  <ID className="!text-left !pl-0">
                    {item?.businessName || `${item.firstName} ${item.lastName}`}
                  </ID>
                  <ID className="!text-left !pl-0">
                    {getDate(item?.createdAt)}
                  </ID>
                  <ID className="!text-left !pl-0">{item?.email}</ID>
                  <ID className="!text-left !pl-0">{item?.phoneNumber}</ID>
                  <ID className="!text-left !pl-0">
                    {Capitalize(item.accountType || "")}
                  </ID>
                  <ID className="!text-left !pl-0">
                    {item.UserSubcription
                      ? item?.UserSubcription?.status
                      : "None"}
                  </ID>
                  <ID className="!text-left !pl-0">
                    {item?.isVerified ? "True" : "False"}
                  </ID>
                  <View>
                    <Link
                      style={{color: `${colours.orange}`}}
                      to={`/customers/${item.id}`}
                    >
                      View more
                    </Link>
                  </View>
                </Row>
              ))
            ) : (
              <tr>
                <td
                  colSpan={8}
                  className="text-center py-8 text-sm text-gray-400"
                >
                  No customers found.
                </td>
              </tr>
            )}

            {/* Pagination */}
            <div className="flex items-center justify-end gap-2 mt-6">
              <button
                onClick={goToPreviousPage}
                disabled={page === 1}
                className={`px-3 py-1.5 rounded border border-gray-300 text-sm ${
                  page === 1
                    ? "text-gray-300 cursor-not-allowed"
                    : "hover:bg-gray-100"
                }`}
              >
                &lt;
              </button>

              {getPaginationGroup().map((item, index) => (
                <button
                  key={index}
                  onClick={() => changePage(item)}
                  className={`px-3 py-1.5 rounded text-sm border ${
                    page === item
                      ? "bg-orange-500 text-white border-orange-500"
                      : "text-gray-700 border-gray-300 hover:bg-gray-100"
                  }`}
                >
                  {item}
                </button>
              ))}

              <button
                onClick={goToNextPage}
                disabled={page >= allCustomers?.paging?.totalPages}
                className={`px-3 py-1.5 rounded border border-gray-300 text-sm ${
                  page >= allCustomers?.paging?.totalPages
                    ? "text-gray-300 cursor-not-allowed"
                    : "hover:bg-gray-100"
                }`}
              >
                &gt;
              </button>

              <button
                onClick={gotolastPage}
                className="px-3 py-1.5 rounded border border-gray-300 text-sm hover:bg-gray-100"
              >
                {/* {allCustomers?.paging?.totalPages} */}*
              </button>
            </div>
          </Table>
        </div>
      </div>
    </AppLayout>
  );
};

const Paginationwrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #4a4a68;

  > button {
    background: #f4f9ff;
    box-shadow: 0px 0px 7px rgba(34, 103, 206, 0.5);
    border-radius: 5px;
  }
  .paginationItem {
    border: none;
    background: #f4f9ff;
    padding: 10px;
    height: 20px;
    width: 20px;
    position: relative;
    margin: 30px 5px;
    cursor: pointer;
  }
  .paginationItem.active {
    border: 1px solid #333333;
  }
  .prev,
  .next {
    background: #f4f9ff;
    border: none;
    padding: 10px;
    height: 20px;
    width: 20px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.4);
    margin: 0 10px;
    cursor: pointer;
  }
`;

const Table = styled.main``;
const Row = styled.div`
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  gap: 0.25%;
  margin: 10px 0;
`;

const RowHeader = styled.div`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 16px;
  margin: 10px 0;
`;

const ID = styled.p`
  font-size: 16px;
  color: #333333;
  width: 13.5%;
  text-align: center;
  font-style: normal;
  font-weight: 400;
  max-width: 13%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const View = styled.p`
  font-size: 16px;
  color: ${colours.orange};
  width: 13.5%;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  max-width: 13%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
const IDHeader = styled(ID)`
  color: #333333;
  font-weight: 700;
`;
